import { createEntityAdapter } from "@reduxjs/toolkit";
import { UserAccessMessage } from "./dataTypes";

export const userAccessMessageAdapter = createEntityAdapter<UserAccessMessage>({});
